/**
 * @description Gestion des images et effets associés
 */

(() => {
	const figureContainer = () => {
		document.querySelectorAll('.figure-full__legend').forEach((figure) => {
			figure.classList.remove('col-lg-9', 'offset-lg-3');
			figure.classList.add('container');
		});
	};

	// GO 🚀
	const init = () => {
		figureContainer();
	};

	init();
})();
